import * as React from "react";

import { maxEmailLength } from "../email-address-constants";
import { InputContainer, InputContainerProps } from "./input-container";

export interface SingleLineTextInputProps extends InputContainerProps {
  className?: string;

  onFocus?: (name: string) => void;
  onChange: (name: string, value: string) => void;
  onBlur: (name: string) => void;

  placeholder?: string;

  type?: string;
  inputMode?: string;
  autoComplete?: string;
  maxLength?: number;
}

export const SingleLineTextInput: React.FunctionComponent<
  SingleLineTextInputProps
> = (props) => {
  const inputMaxLength =
    props.maxLength || (props.type === "email" ? maxEmailLength : undefined);

  return (
    <InputContainer
      {...props}
      className={`single-line-text-input ${props?.className || ""}`}
    >
      <div className="input-immediate-container">
        <input
          type={props.type ? props.type : "text"}
          name={props.name}
          value={props.form[props.name] || ""}
          onFocus={() => props.onFocus?.(props.name)}
          onChange={(event) => props.onChange(props.name, event.target.value)}
          onBlur={() => props.onBlur(props.name)}
          placeholder={props.placeholder}
          title={props.displayName}
          {...(props.inputMode ? { inputMode: props.inputMode } : {})}
          autoComplete={props.autoComplete}
          maxLength={inputMaxLength}
        />
        {props?.children}
      </div>
    </InputContainer>
  );
};
